import { Link } from "react-router-dom";
import { useT } from "@/i18n/LanguageContext";
import { STOICOS_CARDS, STOICOS_CARD_GROUPS, CARD_NUM_LABEL, pickLang, stoicosCardUrl } from "@/data/stoicosCards";

/* StoicOs Cards grid — indexable HTML beside every visual, localised via the
   existing StoicOs language system (EN/NL/DE/FR/ES). Artwork stays English. */
export function StoicosCardSections() {
  const { lang } = useT();
  const P = (v) => pickLang(v, lang);
  return (
    <>
      {STOICOS_CARD_GROUPS.map((g) => {
        const cards = STOICOS_CARDS.filter((c) => c.group === g.id);
        return (
          <section key={g.id} className="mt-20 md:mt-24" data-testid={`stoicos-cards-${g.id}`} aria-labelledby={`cards-${g.id}`}>
            <h2 id={`cards-${g.id}`} className="font-serif text-2xl md:text-3xl text-bone tracking-tight">{P(g.label)}</h2>
            <p className="mt-4 max-w-2xl text-bone/75 font-reading text-base md:text-lg leading-[1.85]">{P(g.blurb)}</p>
            <div className="mt-10 grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-12">
              {cards.map((c) => (
                <figure key={c.slug} className="border border-white/8 bg-ink-elevated/40" data-testid={`stoicos-card-${c.slug}`}>
                  <img src={stoicosCardUrl(c)} alt={P(c.alt)} width={c.w} height={c.h} loading="lazy" className="w-full h-auto" />
                  <figcaption className="p-6 md:p-7">
                    <p className="text-[10px] tracking-[0.3em] uppercase text-gold/70">{P(CARD_NUM_LABEL)} {c.num}</p>
                    <h3 className="mt-2 font-serif text-xl md:text-2xl text-bone tracking-tight">{P(c.title)}</h3>
                    <p className="mt-3 text-bone/75 font-reading text-sm md:text-base leading-[1.8]">{P(c.description)}</p>
                    <ul className="mt-4 space-y-1.5">
                      {c.links.map((l, i) => (
                        <li key={i}>
                          <Link to={l.to} className="text-[13px] text-gold hover:underline font-reading" data-testid={`stoicos-card-link-${c.slug}-${i}`}>{P(l.label)} →</Link>
                        </li>
                      ))}
                    </ul>
                  </figcaption>
                </figure>
              ))}
            </div>
          </section>
        );
      })}
    </>
  );
}
